import React from "react";
import SiteReviews from "../../Components/site-reviews/SiteReviews";
import ScrollTop from "../../Components/Buttons/ScrollTop";
import FamousUniversity from "../../Components/ExamPreparationCards/FamousUniversity";
import HotCoursesHelp from "../../Components/ExamPreparationCards/HotCoursesHelp";
import Certificate from "../../Components/ExamPreparationCards/Certificate";
import BonusSection from "../../Components/BonusSection";
import StudentStories from "../../Components/StudentStories";
import ExamReadMoreSection from "../../Components/ExamReadMoreSection";
import StudyNotesPage from "../../Components/ExamPreparationCards/StudyNotesPage";
import CommonBanner from "../../Components/ExamPreparationCards/CommonBanner";
import Page from "../Metadata/Page";
import BreadCrumb from "../../Components/BreadCrumb/BreadCrumb";

const SepcialStudyNote = () => {
  const subCategoryId = "67b5821bfa3a63e9ddb920e3";
  const categoryId = "67b57f038a01c99610fc51b2";
  const breadCrumbData=[
     { label: "Home", path: "/" },
    { label: "Special Study Notes"},
  ]

  return (
    <>
      <Page subCategoryId={subCategoryId} categoryId={categoryId} />
        <div className="container">
      <div className="row mt-2 mb-2 m-0">
        <BreadCrumb items={breadCrumbData} />
      </div>
      </div>
      <CommonBanner subCategoryId={subCategoryId} />
      <SiteReviews />
      <StudyNotesPage />
      <HotCoursesHelp />
      <FamousUniversity />
      <Certificate />
      <BonusSection subCategoryId={subCategoryId} />
      <ExamReadMoreSection subCategoryId={subCategoryId} />
      <StudentStories />
      <ScrollTop />
    </>
  );
};

export default SepcialStudyNote;
